import { useEffect, useState } from "react";

/**
 * `value`, once it has stayed the same for `delayMs`. Each change restarts the
 * wait, and the timer is cleared on unmount.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
